module.exports = __webpack_public_path__ + "static/underConstruction-d699571bec74ac7411117b1af2139fff.jpg";